import Swal from 'sweetalert2';
import { BehaviorSubject } from 'rxjs';
import { types } from '../types/types';
import { startLoading, finishLoading } from './ui';
import { makePOST } from '../helpers/makeRequest';
export const tokenSubject = new BehaviorSubject((localStorage.getItem('email')));

export const token = tokenSubject.asObservable()

export const startLoginEmailPassword = (username, password) => {
    return (dispatch) => {

        dispatch(startLoading());
        return makePOST("auth/login", { username, password })
            .then((response) => {
                const data = response.data
                dispatch(login(data.token, data.name, username));
                localStorage.setItem('email', username)
                if (data.token) {
                    localStorage.setItem('token', "Bearer " + data.token)
                }
                localStorage.setItem('idRol', data.idRol)
                localStorage.setItem('idUser', data.idUser)
                localStorage.setItem('userProps', JSON.stringify(data))
                if(!localStorage.getItem('selectedClient')){
                    localStorage.setItem('selectedClient', data.clients[0] || '')
                }
                tokenSubject.next("Bearer " + data.token)
                dispatch(finishLoading());
            })
            .catch(e => {
                dispatch(finishLoading());
                Swal.fire('Error', 'Por favor ingrese una contraseña o usuario válidos', 'error');
            })

    }
}

export const login = (uid, displayName, token) => ({
    type: types.login,
    payload: {
        uid,
        displayName,
        token
    }
});

export const startLogout = () => {
    return async (dispatch) => {
        localStorage.removeItem('email')
        localStorage.removeItem('token')
        localStorage.removeItem('idRol')
        localStorage.removeItem('idUser')
        localStorage.removeItem('userProps')
        localStorage.removeItem('selectedClient')
        tokenSubject.next(null)
        dispatch(logout());
    }
}


export const logout = () => ({
    type: types.logout
})


